import React, { createContext, useContext, useState } from 'react';
import {
  EndPointGetVehicle,
  EndPointGetDashWorkVehicle,
  EndPointGetDashWorkVehiclesId,
  EndPointGetDashWork,
  EndPointGetDashWorkProgramated,
  EndPointGetDashWorkGlobal
} from "../Services/EndPointOperation";

import equipo1 from "../assets/img/equipo1 big.png";

// Create the Operation context
export const OperationContext = createContext();

// Custom hook to use the Operation context
export const useOperation = () => {
  const context = useContext(OperationContext);
  if (!context) {
    throw new Error('useOperation must be used within an OperationProvider');
  }
  return context;
};

// Provider component
export const OperationProvider = ({ children }) => {

  const [miningSite, setMiningSite] = useState();

  const [globalData, setGlobalData] = useState({
    data: [],
    total: 0,
    pending: 0,
    finished: 0,
    noProgramated: 0
  });
  
  const [operationData, setOperationData] = useState({
    arrayVehicle: [],
    coordMap: [],
    dataTableGeneral: [],
    dataTableById: [],
    statusTable: "general",
    nameVehicle: "",
    activeIndex: "",
    loading_data_Table: false,
    total: 0,
    pending: 0,
    finished: 0,
    noProgramated: 0
  });

  // UI state
  const [open, setOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [infoOpenMobile, setInfoOpenMobile] = useState(false);
  const [mapMobileOpen, setMapMobileOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(9);


  const fetchGlobalData = async () => {
    try {
      const dashboardWorkResponse = await EndPointGetDashWork('all');
      const dashboardWorkGlobalResponse = await EndPointGetDashWorkGlobal();

      const dashboardData = dashboardWorkResponse.data;
      const dashboardDataGlobal = dashboardWorkGlobalResponse.data;

      setGlobalData({
        data: dashboardDataGlobal,
        total: dashboardData && dashboardData.total ? dashboardData.total : 0,
        pending: dashboardData && dashboardData.pending ? dashboardData.pending : 0,
        finished: dashboardData && dashboardData.finished ? dashboardData.finished : 0,
        noProgramated: dashboardData && dashboardData.noProgramated ? dashboardData.noProgramated : 0
      });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Fetch initial data (replacing componentDidMount)
  const fetchInitialData = async () => {
    try {
      // Load initial data directly from endpoints
      const vehiclesResponse = await EndPointGetVehicle(miningSite);
      const dashboardWorkResponse = await EndPointGetDashWork(miningSite);
      const dashboardVehiclesResponse = await EndPointGetDashWorkVehicle(miningSite);
      
      // Extract data from responses
      const vehiclesData = vehiclesResponse.data;
      const dashboardData = dashboardWorkResponse.data;
      const dashboardVehiclesData = dashboardVehiclesResponse.data;
      
      // Process vehicles data
      const processedVehicles = (vehiclesData.vehicles ? vehiclesData.vehicles : []).map((item, key) => {
        return {
          ...item,
          url: equipo1,
        };
      });

      const processedDashboardVehiclesData = (dashboardVehiclesData.vehicles ? dashboardVehiclesData.vehicles : []).map((item, key) => {
        return {
          ...item,
          idPosition: key + 1,
        };
      });

      const coordinates = processedDashboardVehiclesData.map((coords) => {
        return {
          coordPointsLast: {
            id: coords.idPosition,
            status: "lastPoint",
            coord:
              coords.lastCollectPoint === null
                ? coords.lastCollectPoint
                : {
                    lat: coords.lastCollectPoint.latitude,
                    lng: coords.lastCollectPoint.longitude,
                  },
          },
          coordPointsNext: {
            id: coords.idPosition,
            status: "nextPoint",
            coord:
              coords.nextCollectPoint === null
                ? coords.nextCollectPoint
                : {
                    lat: coords.nextCollectPoint.latitude,
                    lng: coords.nextCollectPoint.longitude,
                  },
          },
        };
      });

      const filterCoordinates = coordinates.map((filter) => Object.values(filter))
        .reduceRight((a, b) => a.concat(b), [])
        .filter((result) => result.coord !== null);
      
      // Update state with fetched data
      setOperationData(prevState => ({
        ...prevState,
        arrayVehicle: processedVehicles,
        coordMap: filterCoordinates,
        dataTableGeneral: processedDashboardVehiclesData,
        dataTableById: [],
        total: dashboardData && dashboardData.total ? dashboardData.total : 0,
        pending: dashboardData && dashboardData.pending ? dashboardData.pending : 0,
        finished: dashboardData && dashboardData.finished ? dashboardData.finished : 0,
        noProgramated: dashboardData && dashboardData.noProgramated ? dashboardData.noProgramated : 0
      }));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Handle map click
  const handleClickMap = (e) => {
    setOpen(!open);
  };

  // Handle pagination
  const onChangePage = (data) => {
    setStartIndex(data.startIndex);
    setEndIndex(data.endIndex);
  };

  // Handle info open
  const handleInfoOpen = (val) => {
    setInfoOpen(val);
  };

  // Handle info open mobile
  const handleInfoOpenMobile = (val) => {
    setInfoOpenMobile(val);
  };

  // Handle map mobile open
  const handleClickMapMobileOpen = () => {
    setMapMobileOpen(true);
  };

  // Handle map mobile close
  const handleClickMapMobileClose = () => {
    setMapMobileOpen(false);
    setInfoOpenMobile(false);
  };
  
  // Handle card click (previously GetVehicleById in Redux)
  const handleCard = async (id, type, name, index) => {
    try {
      // If clicking the same vehicle, reset to general view
      if (operationData.activeIndex === index) {
        await updateVehicleTable();
        return;
      }
      
      setOperationData(prevState => ({
        ...prevState,
        loading_data_Table: true
      }));
      
      // Call the endpoint to get vehicle data by ID
      const response = await EndPointGetDashWorkVehiclesId(id, miningSite);
      const vehicleData = response.data;

      const dataValue = [
        {
          collectPointNumber: "-",
          collectPointLatitude: 0,
          collectPointLongitude: 0,
          collectPointName: "-",
          departmentName: "-",
          totalWeight: "-",
          totalVolume: "-",
          completed: "-",
          segregation: "-",
          estatus: "-",
        },
      ];

      const newresultDataTable =
        vehicleData.collectPoints.length === 0
          ? dataValue
          : vehicleData.collectPoints.map((dat, index) => {
              dat.idPosition = index + 1;
              dat.idVehicles = id;
              dat.complete = dat.completed === undefined ? 0 + "/" + dat.totalSegregation : dat.completed + "/" + dat.totalSegregation;
              dat.segregatio = dat.segregation + "/" + dat.totalSegregation;
              dat.estatus = dat.completed === 0 ? "Pendiente" : dat.completed > 0 && dat.completed < dat.totalSegregation ? "En proceso" : "Finalizado";
              return dat;
            });
    
      const coordinates = newresultDataTable.map((dat) => {
        if (
          dat.collectPointLatitude !== null &&
          dat.collectPointLongitude !== null &&
          dat.collectPointLatitude !== 0 &&
          dat.collectPointLongitude !== 0
        ) {
          return {
            id: dat.collectPointNumber,
            name: dat.collectPointName,
            status: dat.hasIncidents === 0 ? dat.estatus : "Incidente",
    
            coord: {
              lat: dat.collectPointLatitude,
              lng: dat.collectPointLongitude,
            },
          };
        }
        return dat;
      });
      
      setOperationData(prevState => ({
        ...prevState,
        statusTable: "byId",
        nameVehicle: `${type} ${name}`,
        activeIndex: index,
        coordMap: coordinates,
        dataTableById: newresultDataTable,
        loading_data_Table: false
      }));
    } catch (error) {
      console.error('Error getting vehicle by ID:', error);
      setOperationData(prevState => ({
        ...prevState,
        loading_data_Table: false
      }));
    }
  };
  
  // Reset vehicle selection (previously ResetVehicle in Redux)
  const resetVehicle = async () => {
    setOperationData(prevState => ({
      ...prevState,
      activeIndex: "",
      statusTable: "general"
    }));
  };
  
  // Update vehicle table to general view (previously UpdateVehicleTable in Redux)
  const updateVehicleTable = async () => {
    await resetVehicle();
    try {
      setOperationData(prevState => ({
        ...prevState,
        loading_data_Table: true
      }));
      
      // Get general dashboard data
      const dashboardWorkResponse = await EndPointGetDashWorkVehicle(miningSite);
      const dashboardVehiclesData = dashboardWorkResponse.data;

      const processedDashboardVehiclesData = (dashboardVehiclesData.vehicles ? dashboardVehiclesData.vehicles : []).map((item, key) => {
        return {
          ...item,
          idPosition: key + 1,
        };
      });

      const coordinates = processedDashboardVehiclesData.map((coords) => {
        return {
          coordPointsLast: {
            id: coords.idPosition,
            status: "lastPoint",
            coord:
              coords.lastCollectPoint === null
                ? coords.lastCollectPoint
                : {
                    lat: coords.lastCollectPoint.latitude,
                    lng: coords.lastCollectPoint.longitude,
                  },
          },
          coordPointsNext: {
            id: coords.idPosition,
            status: "nextPoint",
            coord:
              coords.nextCollectPoint === null
                ? coords.nextCollectPoint
                : {
                    lat: coords.nextCollectPoint.latitude,
                    lng: coords.nextCollectPoint.longitude,
                  },
          },
        };
      });

      const filterCoordinates = coordinates.map((filter) => Object.values(filter))
        .reduceRight((a, b) => a.concat(b), [])
        .filter((result) => result.coord !== null);
      
      setOperationData(prevState => ({
        ...prevState,
        statusTable: "general",
        dataTableGeneral: processedDashboardVehiclesData,
        coordMap: filterCoordinates,
        loading_data_Table: false
      }));
    } catch (error) {
      console.error('Error updating vehicle table:', error);
      setOperationData(prevState => ({
        ...prevState,
        loading_data_Table: false
      }));
    }
  };
  
  // Get non-programmed vehicles (previously GetVehicleNoProgramated in Redux)
  const handleProgramated = async () => {
    try {
      setOperationData(prevState => ({
        ...prevState,
        loading_data_Table: true
      }));

      const resultDataVehicleTable = await EndPointGetDashWorkProgramated(miningSite);

      const dataValue = [
        {
          collectPointNumber: "-",
          collectPointLatitude: 0,
          collectPointLongitude: 0,
          collectPointName: "-",
          departmentName: "-",
          totalWeight: "-",
          totalVolume: "-",
          completed: "-",
          segregation: "-",
          estatus: "-",
          plateNumber: "-",
        },
      ];

      const newresultDataTable =
        resultDataVehicleTable.data.collectPoints.length === 0
          ? dataValue
          : resultDataVehicleTable.data.collectPoints.map((dat, index) => {
              dat.idPosition = index + 1;
              dat.complete =
                dat.completed === undefined
                  ? 0 + "/" + dat.totalSegregation
                  : dat.completed + "/" + dat.totalSegregation;
              dat.segregatio = dat.segregation + "/" + dat.totalSegregation;
              dat.estatus =
                dat.completed === 0
                  ? "Pendiente"
                  : dat.completed > 0 && dat.completed < dat.totalSegregation
                  ? "En proceso"
                  : "Finalizado";
              return dat;
            });
    
      const coordinates = newresultDataTable.map((dat) => {
        return {
          id: dat.collectPointNumber,
          name: dat.collectPointName,
          status: dat.hasIncidents === 0 ? dat.estatus : "Incidente",
    
          coord: {
            lat: dat.collectPointLatitude,
            lng: dat.collectPointLongitude,
          },
        };
      });
      
      setOperationData(prevState => ({
        ...prevState,
        statusTable: "programated",
        coordMap: coordinates,
        dataTableById: newresultDataTable,
        loading_data_Table: false
      }));

    } catch (error) {
      console.error('Error getting non-programmed vehicles:', error);
      setOperationData(prevState => ({
        ...prevState,
        loading_data_Table: false
      }));
    }
  };

  const contextValue = {
    miningSite,
    setMiningSite,
    operationData,
    setOperationData,
    globalData,
    setGlobalData,
    open,
    setOpen,
    infoOpen,
    setInfoOpen,
    infoOpenMobile,
    setInfoOpenMobile,
    mapMobileOpen,
    setMapMobileOpen,
    startIndex,
    setStartIndex,
    endIndex,
    setEndIndex,
    handleClickMap,
    onChangePage,
    handleInfoOpen,
    handleInfoOpenMobile,
    handleClickMapMobileOpen,
    handleClickMapMobileClose,
    fetchInitialData,
    fetchGlobalData,
    handleCard,
    resetVehicle,
    updateVehicleTable,
    handleProgramated
  };

  return (
    <OperationContext.Provider value={contextValue}>
      {children}
    </OperationContext.Provider>
  );
};
